import { render, staticRenderFns } from "./ManageMembersModal.vue?vue&type=template&id=45173874&"
import script from "./ManageMembersModal.vue?vue&type=script&lang=js&"
export * from "./ManageMembersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports